export default "__VITE_ASSET__k8Ta41TJ__"